import { IPermission } from './IPermission';
export class IPermissionRole{
    id: number = 0;
    name: string = "";
    permissions: Array<IPermission> = [];
}